import { CCallout } from './CCallout.js';

const CCalloutPlugin = {
    install: (app) => {
        app.component(CCallout.name, CCallout);
    },
};

export { CCallout, CCalloutPlugin };
//# sourceMappingURL=index.js.map
